import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel, Grid, SvgIcon, Menu } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { Link } from "@material-ui/core";
import { Button } from "@material-ui/core";
import AddIcon from "@mui/icons-material/Add";
import toast from "react-hot-toast";

import {
  getDate,
  editTicketPath,
  searchFilter,
  handleSort,
  editInternalSupportPath,
} from "../utils/varialbles";
import http from "../services/httpService";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import SearchBar from "material-ui-search-bar";
import Filter from "../components/filerComponent";
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import filterData from "../components/filterCriteria";
import staticFiles from "../services/staticApi";

const columns = [
  { label: "ID", id: "id" },
  { label: "Issue", id: "issue", minWidth: 170, type: "link" },
  {
    label: "Created",
    id: "ticket_created_at",
    minWidth: 150,
    format: "Date",
    filter: true,
    filterType: "date",
    conditions: [
      { text: "less than", value: "lte" },
      { text: "greater than", value: "gte" },
    ],
  },
  {
    label: "Reporter",
    id: "reporter",
    minWidth: 150,
    filter: true,
    filterType: "dropDown",
    conditions: [{ text: "Equal", value: "eq" }],
    options: "data",
    multi: true,
  },
  {
    label: "Assigned To",
    id: "assigned",
    minWidth: 150,
    filter: true,
    filterType: "dropDown",
    conditions: [{ text: "Equal", value: "eq" }],
    options: "data",
    multi: true,
  },
  { label: "Request Type", id: "requesttype", minWidth: 150 },

  {
    label: "Issue Type",
    id: "issue_type",
    minWidth: 150,
    filter: true,
    filterType: "dropDown",
    conditions: [{ text: "Equal", value: "eq" }],
    options: "data",
    multi: true,
  },
  {
    label: "Severity",
    id: "severity",
    minWidth: 150,
    filter: true,
    filterType: "dropDown",
    conditions: [{ text: "Equal", value: "eq" }],
    options: "data",
    multi: true,
  },
  {
    label: "Status",
    id: "status",
    minWidth: 150,
    filter: true,
    filterType: "dropDown",
    conditions: [{ text: "Equal", value: "eq" }],
    options: "data",
    multi: false,
  },
  { label: "Satisfaction", id: "satisfaction", minWidth: 150 },
  { label: "Attachment", id: "attachment", minWidth: 170, type: "attach" },
  { label: "Comments", id: "comments", minWidth: 150 },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

function Viewinternalsupport() {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const isMenuOpen = Boolean(anchorEl);
  const location = useLocation();
  const myparam = location.state;
  const isMenuOpen = anchorEl;
  const form = {
    // issue_type: [],
    // ticket_created_at: "",
    // ticket_created_at__condition: "lte",
    // reporter: [],
    // assigned: [],
    // severity: [],
    // status: "",
  };
  const [formObject, setFormObject] = React.useState(form);

  const clearFilter = () => {
    setFormObject(form);
    setRows(orignalRows);
    localStorage.removeItem("internalFilter");
  };

  const applyFilter = (e) => {
    localStorage.setItem("internalFilter", JSON.stringify(formObject));
    setAnchorEl(null);
    let tempObject = { ...formObject };
    let tempORows = [...orignalRows];
    let filter = filterData(tempObject, tempORows, columns);
    setRows(filter);
    setPage(0);
  };
  const openFilter = (e) => {
    // let currentTarget = e.currentTarget;
    // setAnchorEl(currentTarget);
    setAnchorEl(true);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const closeFilter = () => {
    setAnchorEl(null);
  };
  const handleChange = (e) => {
    setFormObject({
      ...formObject,
      [e.target.name]: e.target.value,
    });
  };
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const viewDetails = (object) => {
    object.page = page;
    history.push({
      pathname: editInternalSupportPath,
      state: object,
    });
  };

  useEffect(() => {
    var getObj = JSON.parse(localStorage.getItem("internalFilter"));
    if (getObj !== null) {
      let internalFilters = {
        ...formObject,
        issue_type: getObj.issue_type,
        reporter: getObj.reporter,
        severity: getObj.severity,
        status: getObj.status,
        assigned: getObj.assigned,
      };
      setFormObject(internalFilters);
    }
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");
    let emp_no = localStorage.getItem("employee_id");
    toast.loading("Please wait...");

    http
      .get("/ticketlist?type=2")
      .then((response) => {
        toast.dismiss();

        if (response && response.data && response.data.length > 0) {
          let finalData = [];
          let tempDta = response.data;
          let tempStatusDta = tempDta.map((item, index) => {
            const swapValue = (item) => {
              Object.keys(item).forEach((key) => {
                // if (!item[key]) {
                //     item[key] = "N/A";
                // }
              });
            };
            swapValue(item);

            if (item.attachment === "") {
              finalData.push((item.attachment = "N/A"));
            } else {
              finalData.push(item.attachment);
            }

            if (item.satisfaction === null) {
              finalData.push((item.satisfaction = "N/A"));
            } else {
              finalData.push(item.satisfaction);
            }
            if (item.comments === null) {
              finalData.push((item.comments = "N/A"));
            } else {
              finalData.push(item.comments);
            }
            return item;
          });
          setOriginalRows(tempDta);
          setRows(tempDta);
        }
      })
      .catch((error) => {});

    if (myparam && myparam.page) {
      setPage(myparam.page);
      delete myparam.page;
    }
  }, [page, rowsPerPage]);

  return (
    <div>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<AddIcon />}
        onClick={() => history.push("/dashboard/addinternalsupport")}
      >
        add internal support
      </Button>
      <Paper className={classes.root}>
        <SearchBar
          value={searched}
          onChange={(searchVal) => requestSearch(searchVal)}
          onCancelSearch={() => cancelSearch()}
          className={"mt30"}
        />
        <Grid container>
          <Grid item xs={10} sm={11} style={{ paddingTop: 10 }}>
            <TablePagination
              rowsPerPageOptions={[10, 50, 100, 1500]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
          <Grid item xs={2} sm={1}>
            <SvgIcon
              style={{ cursor: "pointer", marginTop: 20 }}
              onClick={openFilter}
              title={"filter"}
            >
              <FilterLogo />
            </SvgIcon>
            <Menu
              anchorEl={anchorEl}
              id={"Filtermenu"}
              keepMounted
              open={isMenuOpen}
              onClose={handleMenuClose}
              getContentAnchorEl={null}
              transformOrigin={{ horizontal: "rigth", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <Filter
                columns={columns}
                applyFilter={applyFilter}
                orignalRows={orignalRows}
                handleChange={handleChange}
                formObject={formObject}
                clearFilter={clearFilter}
                closeFilter={closeFilter}
              />
            </Menu>
          </Grid>
        </Grid>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="prospect_table"
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length !== 0 ? (
                <>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index + "a"}
                          className="prospecttable"
                        >
                          {columns.map((column, index) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={index + column.id}
                                align={column.align}
                              >
                                {column.format && typeof value === "number" ? (
                                  column.format(value)
                                ) : column.id === "detailsButton" ? (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ borderRadius: 20 }}
                                    onClick={() => viewDetails(row)}
                                  >
                                    View Details
                                  </Button>
                                ) : column.format === "Date" ? (
                                  getDate(value)
                                ) : column.operation &&
                                  column.operation === "concate" ? (
                                  value + column.operand + row[column.with]
                                ) : column.type &&
                                  column.type === "link" &&
                                  value ? (
                                  <Link
                                    variant="body2"
                                    onClick={(e) => viewDetails(row)}
                                    gutterBottom
                                    style={{ cursor: "pointer" }}
                                  >
                                    {value}
                                  </Link>
                                ) : column.type &&
                                  column.type === "attach" &&
                                  value !== "N/A" ? (
                                  <Link
                                    href={staticFiles + value}
                                    target="_blank"
                                    variant="body2"
                                    gutterBottom
                                    style={{ cursor: "pointer" }}
                                  >
                                    {value}
                                  </Link>
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </>
              ) : (
                <TableCell
                  colspan="7"
                  style={{ "text-align": "center", margin: "10px 0px" }}
                >
                  Data Not Available
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <div>
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 1500]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    </div>
  );
}
export default Viewinternalsupport;
